<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '~/types/types'

/**
 * Agency's `team` settings. Adds the source picker on top of the shared
 * layer's manual-member form (SiteSettingsTeamSettings), which now owns the
 * member fields including bios and social links.
 */
defineProps<{ block: SiteBlock }>()
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField
    label="Source"
    help="Bookable staff stays in sync with your bookable profiles automatically."
  >
    <USelect
      v-model="block.data.source"
      :items="[
        { label: 'Manual list', value: 'manual' },
        { label: 'Bookable staff', value: 'bookable_staff' }
      ]"
      class="w-full"
    />
  </UFormField>

  <SiteSettingsTeamSettings
    v-if="block.data.source !== 'bookable_staff'"
    :block="block"
  />
</template>
